// Traducciones al español
// LTR — direction: ltr

export const ES = {
  lang: 'es',
  dir: 'ltr',

  nav: {
    home: 'Inicio',
    back: 'Volver',
    modules: 'Módulos',
    about: 'Acerca de',
    start: 'Empezar',
    close: 'Cerrar',
    jeexplique: 'Cómo funciona',
    guide: 'Guía',
    textLarger: '¿Texto más grande?',
  },

  hero: {
    tag: 'Gratuito — Sin registro — Sin juicios',
    title: 'La administración francesa,\nsin estrés',
    subtitle: 'Aprende a realizar tus trámites en línea, paso a paso, con palabras sencillas.',
    cta: 'Empezar el test →',
    explain: '¿Cómo funciona?',
    badge: '✦ 3 preguntas rápidas → tu recorrido personalizado en directo',
  },

  stats: {
    people: 'El 34% carece de competencias digitales',
    lessons: 'lecciones disponibles',
    lessonsCompleted: 'lecciones completadas',
    free: 'siempre gratis',
    modules: 'temas del día a día',
    statsTitle: '📊 En Francia hoy',
    sourceBtn: '📰 Leer la fuente',
    stat1num: '15%',
    stat1label: 'de la población en situación de exclusión digital (INSEE 2023)',
    stat2num: '28%',
    stat2label: 'tienen competencias digitales débiles (Crédoc 2022)',
    stat3num: '29%',
    stat3label: 'no realizó ningún trámite desmaterializado en 12 meses (Crédoc 2022)',
  },

  modules: {
    sectionTitle: '📚 Todos los módulos',
    title: 'Elige tu módulo',
    subtitle: 'Cada módulo resuelve un problema concreto del día a día',
    lessons: 'lecciones',
    completed: 'completado',
    progress: 'Tu progreso',
    start: 'Empezar ←',
    continue: 'Continuar ←',
    done: '✓ Completado',
  },

  moduleNames: {
    courrier:       'Leer el correo oficial',
    pdf:            'Rellenar un PDF',
    email:          'Los correos electrónicos',
    dossier:        'Preparar un expediente',
    securite:       'Seguridad digital',
    impots:         'Declaración de impuestos',
    cartevitale:    'Carte Vitale & Salud',
    rsacaf:         'Todo sobre la CAF',
    logement:       'Vivienda & APL',
    dossiermedical: 'Expediente médico',
    formation:      'Formación profesional',
    permis:         'Carnet de conducir',
    banque:         'Cuenta bancaria',
    smartphone:     'Smartphone para principiantes',
  },

  lesson: {
    context: 'Situación',
    question: 'Pregunta',
    validate: 'Validar ✓',
    correct: '✅ ¡Respuesta correcta!',
    wrong: '❌ No del todo…',
    next: 'Siguiente lección →',
    finish: '🎉 Terminar el módulo',
    explanation: 'Explicación',
    lessonOf: 'Lección {n} de {total}',
  },

  moduleEnd: {
    congrats: '🎉',
    title: '¡Módulo completado!',
    desc: '¡Bravo! Has completado el módulo',
    desc2: 'Cada lección aprendida es un trámite menos que temer. ¡Sigue así! 💪',
    nextModule: 'Módulo siguiente',
    allModules: 'Ver todos los módulos',
  },

  onboarding: {
    title: 'Encuentra tu punto de partida',
    subtitle: '3 preguntas rápidas para personalizar tu recorrido',
    questions: [
      {
        id: 'besoin',
        question: '¿Qué te trae aquí hoy?',
        emoji: '🎯',
        options: [
          { id: 'courrier', text: '📬 Recibí una carta oficial y no la entiendo', module: 'courrier' },
          { id: 'pdf', text: '📄 Necesito rellenar un formulario en línea o un PDF', module: 'pdf' },
          { id: 'email', text: '✉️ Necesito enviar un correo a un organismo', module: 'email' },
          { id: 'dossier', text: '📁 Necesito preparar un expediente (vivienda, CAF, trabajo…)', module: 'dossier' },
          { id: 'securite', text: '🔒 Me preocupan las estafas y quiero proteger mis datos', module: 'securite' },
          { id: 'impots', text: '🧾 Debo hacer mi declaración de impuestos y no sé cómo', module: 'impots' },
          { id: 'cartevitale', text: '💊 Tengo preguntas sobre mi Carte Vitale o los reembolsos', module: 'cartevitale' },
          { id: 'rsacaf', text: '🏛️ Quiero conocer mis derechos en la CAF — RSA, prestaciones, ayudas', module: 'rsacaf' },
          { id: 'logement', text: '🏠 Busco una vivienda social o quiero entender mis derechos', module: 'logement' },
          { id: 'dossiermedical', text: '🏥 Quiero acceder a mi expediente médico u organizar mis documentos de salud', module: 'dossiermedical' },
        ]
      },
      {
        id: 'niveau',
        question: '¿Cómo te describirías?',
        emoji: '📊',
        options: [
          { id: 'debutant', text: '🌱 Principiante — lo digital me da miedo' },
          { id: 'moyen', text: '🌿 Bastante cómodo — me apaño pero tengo lagunas' },
          { id: 'avance', text: '🌳 Cómodo — solo quiero entender los trámites administrativos' },
        ]
      },
      {
        id: 'appareil',
        question: 'Usas principalmente…',
        emoji: '📱',
        options: [
          { id: 'telephone', text: '📱 Mi teléfono' },
          { id: 'ordinateur', text: '💻 Mi ordenador' },
          { id: 'les_deux', text: '📱💻 Los dos' },
        ]
      },
    ],
    messages: {
      courrier: { titre: 'Empecemos por el correo oficial', desc: 'A menudo ahí es donde todo se bloquea. Lo desmitificaremos juntos.', module: 'courrier' },
      pdf: { titre: 'Afrontemos los PDF', desc: 'Rellenar un formulario PDF sin estrés — es posible. Te lo mostramos.', module: 'pdf' },
      email: { titre: 'Dominemos los correos', desc: 'Enviar adjuntos, reconocer estafas — paso a paso.', module: 'email' },
      dossier: { titre: 'Preparemos tu expediente', desc: 'Reunir los documentos correctos en el momento adecuado — te guiamos.', module: 'dossier' },
      securite: { titre: 'Protejamos tus datos', desc: 'Reconocer estafas, proteger tus cuentas — estarás tranquilo.', module: 'securite' },
      impots: { titre: 'Hagamos tu declaración de impuestos juntos', desc: 'Paso a paso en impots.gouv.fr — listo en pocos minutos.', module: 'impots' },
      cartevitale: { titre: 'Dominemos tu Carte Vitale', desc: 'Ameli, reembolsos, actualización — te explicamos todo.', module: 'cartevitale' },
      rsacaf: { titre: 'Descubramos todo lo que la CAF puede hacer por ti', desc: 'RSA, prestaciones, PAJE — simula tus derechos en minutos.', module: 'rsacaf' },
      logement: { titre: 'Encontremos tu vivienda', desc: 'Solicitud HLM, APL, derechos del inquilino — te guiamos paso a paso.', module: 'logement' },
      dossiermedical: { titre: 'Gestionemos tu expediente médico', desc: 'Mon Espace Santé, recetas, derechos del paciente — todo explicado.', module: 'dossiermedical' },
    },
  },

  about: {
    tag: 'Acerca de',
    title: 'DémarchesClaires — La administración para todos',
    mission: 'Un proyecto gratuito y de código abierto para ayudar a las personas en situación de exclusión digital a realizar sus trámites administrativos en línea.',
    persona: 'Marie, 62 años, recibe una carta de la CAF que pide documentos en 15 días. DémarchesClaires le permite completar el trámite sola.',
    team: 'El equipo',
    openSource: 'Código abierto',
  },

  footer: {
    home: 'Inicio',
    modules: 'Módulos',
    progress: 'Progreso',
    about: 'Acerca de',
    contact: 'Contáctanos',
    mention: 'Un proyecto cívico · Código abierto · Datos protegidos',
  },

  burger: {
    navigation: 'Navegación',
    modules: 'Módulos',
    home: 'Inicio',
    about: 'Acerca de',
    language: 'Idioma',
  },

  badges: {
    courrier:       'Experto en Correo',
    pdf:            'Maestro PDF',
    email:          'Pro Email',
    dossier:        'As de Expedientes',
    securite:       'Guardián Digital',
    impots:         'Experto Fiscal',
    cartevitale:    'Experto en Salud',
    rsacaf:         'Experto CAF',
    logement:       'Experto en Vivienda',
    dossiermedical: 'Experto en Expediente Médico',
    formation:      'Experto en Formación',
    permis:         'Experto en Carnet',
    banque:         'Experto Bancario',
    smartphone:     'Experto Smartphone',
  },

  testimonials: {
    title: 'Sus testimonios',
    t1: { name: 'Claudette, 71 años — Creuse', text: 'Me perdía mis citas Ameli porque no sabía cómo conectarme. Ahora lo gestiono sola.' },
    t2: { name: 'Rachid, 44 años — Seine-Saint-Denis', text: 'Nunca había hecho mi declaración de impuestos en línea. Con el módulo dedicado, lo hice solo en 20 minutos.' },
  },


  persona: {
    sectionTitle: 'Como nosotros',
    name: 'Marie, 62 años',
    story: 'Recibe una carta de la CAF que exige documentos en 15 días. El lenguaje administrativo, rellenar un PDF, escanear archivos — todo la supera. El estrés aumenta.',
    result: '✓ Con DémarchesClaires, Marie completa su trámite sola en pocos días. Confianza recuperada.',
  },

  ia: {
    title: 'La IA en el corazón de DémarchesClaires',
    desc: 'No una clase magistral. Una IA que observa, se adapta y te guía personalmente.',
    features: [
      { icon: '🎯', label: 'Diagnóstico', desc: 'Evalúa tu nivel' },
      { icon: '🔄', label: 'Camino personal', desc: 'Adaptado a ti' },
      { icon: '💡', label: 'Retroalimentación', desc: 'Explica los errores' },
    ],
  },


  situations: {
    title: '🚨 ¿Tienes un problema ahora?',
    subtitle: 'Haz clic en tu situación — te guiamos directamente.',
    courrier: "He recibido una carta oficial que no entiendo",
    courrierSub: 'CAF, impuestos, prefectura…',
    pdf: "Me piden rellenar o firmar un formulario",
    pdfSub: 'PDF, formulario oficial, documento en línea…',
    caf: "Quiero conocer mis derechos y ayudas",
    cafSub: 'RSA, APL, prestaciones familiares, CAF…',
    sante: "Tengo una pregunta sobre mi salud o reembolsos",
    santeSub: 'Carte Vitale, Ameli, seguro médico…',
    logement: "Tengo un problema con mi vivienda",
    logementSub: 'Alquiler, desahucio, APL, vivienda social…',
  },
  marie: {
    title: 'Marie, 62 años — carta de la CAF recibida esta mañana',
    desc: 'El lenguaje administrativo, rellenar un PDF, escanear un documento — todo eso la supera. Con DémarchesClaires, resuelve su trámite sola,',
    highlight: 'en menos de 15 minutos',
    badge1: 'Gratis',
    badge2: 'Sin registro',
    badge3: 'Sin juicios',
  },

  quefaire: {
    title: '¿Una carta te preocupa?',
    sub: 'Te decimos qué significa y qué debes hacer — en palabras sencillas.',
  },

  contact: {
    title: 'Escribirnos',
    sub: '¿Una pregunta? ¿Una sugerencia? Escríbenos.',
    name: 'Tu nombre *',
    email: 'Tu email (para responderte)',
    message: 'Tu mensaje *',
    send: 'Enviar el mensaje',
    sending: 'Enviando...',
    ok: '✅ ¡Mensaje enviado! Gracias.',
    err: '❌ Error. Inténtalo de nuevo.',
  },

  errors: {
    moduleNotFound: 'Módulo no encontrado',
  },

  stickyFooter: {
    title: '¿No sabes por dónde empezar?',
    subtitle: '3 preguntas → tu recorrido personalizado',
    cta: 'Empezar el test →',
  },
  heroV2: {
    hero_title: "Deja de sufrir con\nlos tr\u00e1mites administrativos",
    hero_subtitle: "Pega tu carta. Nuestra IA la analiza y te gu\u00eda en 5 segundos.",
    hero_badge: "IA \u00b7 7 idiomas \u00b7 Gratis",
    hero_cta_main: "\u26a1 Analizar ahora",
    hero_cta_demo: "Ver la demo (30s)",
    hero_reassurance1: "\u2713 Sin registro",
    hero_reassurance2: "\u2713 Datos eliminados tras el an\u00e1lisis",
    demo_title: "Ve el resultado antes de empezar",
    demo_subtitle: "Esto es lo que produce la IA en 5 segundos con una carta real",
    demo_analyse: "Mistral est\u00e1 analizando tu carta",
    demo_cta: "Analizar mi carta \u2192",
    demo_courrier: "Estimado/a Se\u00f1or/a,\nLe informamos que su expediente CAF n\u00b0 2847156 ha sido suspendido. Debe aportar sus justificantes de ingresos antes del 18 de febrero de 2026.",
    demo_reponse: "\ud83d\udccb La CAF ha suspendido sus ayudas\n\n\u2705 Qu\u00e9 hacer:\n1. Re\u00fana sus n\u00f3minas (\u00faltimos 3 meses)\n2. Env\u00edelas por caf.fr o en persona\n\u23f0 Plazo: antes del 18 de febrero \u2014 urgente!",
  },
};
